import axios from 'axios'
import { IhLogUrl, metricUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 电子围栏区域是否到岗
export function geoFencesNumber(params) {
  const url = IhLogUrl + '/geoFences/work/number'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '查询电子围栏区域到岗数据', res)
    }
    return Promise.resolve(res.data)
  })
}
// 人员活跃、数据统计
export function activeStatisticsPage(params) {
  const url = IhLogUrl + '/active/statistics/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '查询人员活跃、数据统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 导出人员考勤统计
export function workExportStatistics(params) {
  const url = IhLogUrl + '/work/record/export/statistics'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '导出人员考勤统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 人员考勤统计
export function workRecordStatistics(params) {
  const url = metricUrl + '/work/record/statistics'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '人员考勤统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 人员活跃、数据统计
export function statisticsPage(params) {
  const url = IhLogUrl + '/active/statistics/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '人员活跃、数据统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 围栏进出统计
export function geoFencesInOutStatistics(params) {
  const url = IhLogUrl + '/geoFences/statistics'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '围栏进出统计', res)
    }
    return Promise.resolve(res.data)
  })
}

// 人员考勤统计
export function geoFencesStatistics(params) {
  const url = metricUrl + '/geofence/statistics'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {//NOSONAR
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('人员管理', '人员考勤统计', res)
    }
    return Promise.resolve(res.data)
  })
}

//导出人员考勤统计
export function getExportStatisticse(params) {
  const url = metricUrl + '/geofence/export/statistics'
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '导出人员考勤统计', res)
    }
    return Promise.resolve(res.data)
  })
}
